import { css } from 'styled-components';
import {
  getSpacing, SpacingName, BreakpointQueryName, getTypography, TypographyName, ThemedFunctor, rgba,
} from '@doveit/lego';

export const minimalToolboxWrapper: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.padding(theme, SpacingName.SMALL)}
  width: 100%;
`;

export const gallery: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.margin(theme, [0, SpacingName.NEGATIVE_SMALL, SpacingName.SMALLER])}
  position: relative;

  &:hover {
    cursor: pointer;
  }

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    margin-left: 0;
    margin-right: 0;
  }
`;

export const sold: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.H2)}
  text-align: center;
  background-color: ${rgba(theme.palettes.brand.primary, 0.8)};
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  padding: 1rem;
  transform: translateY(-50%);
  color: ${theme.palettes.neutrals.lightest};
  text-transform: uppercase;
  z-index: 2;
`;

export const imageCount = css`
  position: absolute;
  right: 1rem;
  bottom: 1rem;
`;
